import React, { useEffect, useState } from 'react'
import GaleryHome from '../Components/Sections/about/GaleryHome'
import ArticleHome from '../Components/Sections/about/ArticleHome'
import FaireDon from '../Components/Sections/about/FaireDon'
import Soutient from '../Components/Sections/about/Soutient'
import Chiffre from './Chiffre'
import { fetchListItems } from '../../../hooks/useCrud'
import DOMPurify from 'dompurify';
import Programme from '../Components/Sections/about/Programme'
import Partenaire from '../Components/Sections/home/Partenaire'

interface Site {
    id?: number;
    nom?: string;
    description?: string;
    email?: string;
    adresse?: string;
    tel1?: string;
    tel2?: string;
    tel3?: string;
    token?: string;
    about?: string;
    mission?: string;
    objectif?: string;
    politique?: string;
    condition?: string;
    logo?: string;
    logoFile?: File;
    facebook?: string;
    linkedin?: string;
    twitter?: string;
    youtube?: string;
    whatsapp?: string;
    createdAt?: string;
    updatedAt?: string;
}

export default function HommeIntro() {
    // fin langue
    const [sites, setSites] = useState<Site[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<Site>('/fetch_data_site');
            setSites(res.data);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchData();

    }, []);

    return (
        <div className='col-md-12'>




            {sites.map((item, index) => (

                <div key={index}>

                    <div className="panel p-4 bg-gray-25 dark:bg-gray-800 rounded-lg h-100">
                        <div className="block-header px-2 lg:px-0 text-center">
                            <h2 className="h4 md:h3 m-0">
                                <i className="fas fa-basketball-ball text-primary"></i>
                                <span>Notre Histoire</span>
                            </h2>
                            <p className="fs-6 mt-2 text-gray-600 dark:text-gray-400">De la passion du basketball à l'excellence sportive au Congo</p>
                            <h3 className="h4 m-0  mb-2">Ouragan Academy</h3>
                        </div>
                        <div className="vstack gap-3">


                            <div dangerouslySetInnerHTML={{ __html: item.about || '' }}></div>

                            {/* Section Réalisations start */}
                            <Chiffre />
                            {/* Section Réalisations end */}

                        </div>
                    </div>


                    <div className="panel p-4 bg-gray-25 dark:bg-gray-800 rounded-lg">
                        <div className="vstack gap-3">
                            <h3 className="h5 m-0 text-primary">
                                <i className="fas fa-bullseye"></i>
                                Objectifs et Missions
                            </h3>

                            {/* Objectif */}
                            <div className="vstack gap-2">
                                <h4 className="h6 m-0 text-dark text-primary">Objectif</h4>
                                <p className="fs-6 m-0 text-gray-600">

                                    <div dangerouslySetInnerHTML={{ __html: item.objectif || '' }}></div>
                                </p>
                            </div>

                            {/* Mission */}
                            <div className="vstack gap-2">
                                <h4 className="h6 m-0 text-dark text-primary">Mission</h4>
                                <p className="fs-6 m-0 text-gray-600">
                                    <div dangerouslySetInnerHTML={{ __html: item.mission || '' }}></div>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>



            ))}

            <div className="section panel overflow-hidden mt-3">
                <div className="section-outer panel py-4 md:py-6 lg:py-8 xl:py-9 bg-gray-25 dark:bg-gray-900">
                    <div className="container max-w-2xl p-0 sm:px-2 lg:px-4 xl:px-0">
                        <div className="section-inner">
                            <div className="block-layout grid-layout vstack gap-3 sm:gap-4 xl:gap-5 panel">
                                <div className="block-header px-2 lg:px-0 text-center">
                                    <h2 className="h4 md:h3 m-0">
                                        <i className="fas fa-chart-line text-primary"></i>
                                        <span>Nos Performances</span>
                                    </h2>
                                    <p className="fs-6 mt-2 text-gray-600 dark:text-gray-400">L'excellence sportive au service du développement</p>
                                </div>
                                <div className="block-content container max-w-3xl">
                                    <div className="row child-cols-12 sm:child-cols-2 lg:child-cols-4 g-2">
                                        <div className="text-center">
                                            <div className="panel p-4 bg-white dark:bg-gray-800 rounded-lg vstack gap-2">
                                                <div className="w-80px h-80px bg-primary bg-opacity-10 rounded-circle hstack justify-center items-center mx-auto">
                                                    <i className="fas fa-trophy text-primary text-2xl"></i>
                                                </div>
                                                <h3 className="h2 m-0 text-primary">25+</h3>
                                                <h4 className="h5 m-0">Tournois</h4>
                                                <p className="fs-7 m-0 text-gray-600">Compétitions remportées</p>
                                            </div>
                                        </div>
                                        <div className="text-center">
                                            <div className="panel p-4 bg-white dark:bg-gray-800 rounded-lg vstack gap-2">
                                                <div className="w-80px h-80px bg-primary bg-opacity-10 rounded-circle hstack justify-center items-center mx-auto">
                                                    <i className="fas fa-user-graduate text-primary text-2xl"></i>
                                                </div>
                                                <h3 className="h2 m-0 text-primary">50+</h3>
                                                <h4 className="h5 m-0">Talents</h4>
                                                <p className="fs-7 m-0 text-gray-600">Détectés et formés</p>
                                            </div>
                                        </div>

                                        <div className="text-center">
                                            <div className="panel p-4 bg-white dark:bg-gray-800 rounded-lg vstack gap-2">
                                                <div className="w-80px h-80px bg-primary bg-opacity-10 rounded-circle hstack justify-center items-center mx-auto">
                                                    <i className="fas fa-basketball-ball text-primary text-2xl"></i>
                                                </div>
                                                <h3 className="h2 m-0 text-primary">2</h3>
                                                <h4 className="h5 m-0">Infrastructures</h4>
                                                <p className="fs-7 m-0 text-gray-600">Terrains développés</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>




            {/* Pourquoi soutenir Eubabu ?*/}
            <Soutient />
            {/* Pourquoi soutenir Eubabu ?*/}

            {/* programme de formation */}
            <Programme />

            {/* dateTime// Fancy Title \\*/}
            <FaireDon />









        </div>
    )
}
